export {};

const devMode = false;
// const scriptUrl = 'http://localhost:8080/app-web-notifications.js';

const scriptUrl =
  'https://app.infigy.cz/portal-assets/app-web-notifications.js';

const shouldLoadScript =
  window.location.href.includes('app.infigy.cz') || devMode;

if (shouldLoadScript) {
  const script = document.createElement('script');
  script.src = scriptUrl;
  script.async = true;
  document.head.appendChild(script);
}
